import { render } from "./ReceiveCode.vue?vue&type=template&id=47cebbfb"
import script from "./ReceiveCode.vue?vue&type=script&lang=js"
export * from "./ReceiveCode.vue?vue&type=script&lang=js"

import "./ReceiveCode.vue?vue&type=style&index=0&id=47cebbfb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__